import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import InternalGate from './pages/InternalGate'
import './index.css'

// Internal-only gate. On the environments where VITE_INTERNAL_ONLY is '1'
// (dev/stage) the SPA is wrapped in an email-OTP wall that admits only seeded
// internal users; everywhere else the component is a passthrough.
//
// ⚠ THE DECISION IS MADE HERE, not inside the component, and the flag is
//   inlined at build time — so in production the gate is dead code and the
//   bundler drops it entirely rather than shipping a wall that merely chooses
//   not to appear.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <InternalGate>
      <App />
    </InternalGate>
  </React.StrictMode>
)
